import React, { useEffect, useState } from "react";
import { getAccessToken } from "../auth";
import { useLocation, useNavigate } from "react-router-dom";
import { getRedirectPath } from "../utils/comman";
import CustomLoader from "../components/Comman/CustomLoader/CustomLoader";

export const roleBasedRedirect: { [key: number]: string } = {
  1: "/admin/dashboard",
  2: "/leader/dashboard",
  3: "/controller/dashboard",
  4: "/dashboard",
};

const AuthWrapper: React.FC<any> = ({ children, roleId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);

  const publicRoutes = [
    "/",
    // "/login",
    "/register",
    // "/admin/login",
    "/change-password",
    "/forgot-password",
    "/terms-and-conditions",
    "/contact-us",
    "/signin",
    "/signup",
    "/auth",
    "/privacy-policy",
  ];

  const isLoggedin = getAccessToken();

  const checkLogin = (token: string | null, roleId: number) => {
    if (token) {
      const defaultRedirect = roleBasedRedirect[roleId];

      // ✅ Only redirect if the user is on a public page
      if (publicRoutes.includes(location.pathname)) {
        navigate(defaultRedirect, { replace: true });
      }
    } else if (!publicRoutes.includes(location.pathname)) {
      navigate(getRedirectPath(), { replace: true });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    // Allow these paths regardless of login state
    if (
      ["/admin/reset-password", "/reset-password"].includes(location.pathname)
    ) {
      return;
    }

    // ✅ Prevent redirect loop by only redirecting if on a public page
    checkLogin(token, roleId);
  }, [isLoggedin, roleId]); // Removed `location.pathname` from dependencies to prevent unnecessary redirects

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  if (loading) {
    return (
      <CustomLoader>
        <>{children}</>
      </CustomLoader>
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
